import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import { LanguageProvider } from "./context/LanguageContext"; // Import LanguageProvider
import Layout from "./components/layout";

// General Components
import NotFound from "./components/notFound";
import Home from "./components/home";
import ContactUs from "./pages/contact-us";

// Environmental Pages
import Monitoring from "./pages/environmental/monitoring";
import Laboratory from "./pages/environmental/laboratory";
import Consultancy from "./pages/environmental/consultancy";
import Equipment from "./pages/environmental/equipment";
import Investigation from "./pages/environmental/investigation";
import Decarbonization from "./pages/environmental/decarbonization";


// Oil & Gas Pages
import DrillingFluids from "./pages/oil-gas/drilling-fluids";
import CompletionFluids from "./pages/oil-gas/completion-fluids";
import SolidControl from "./pages/oil-gas/solid-control";
import Consulting from "./pages/oil-gas/consulting";
import ChemicalProducts from "./pages/oil-gas/chemical-products";

// Footer Pages
import WorkWithUs from "./pages/workWithUs";
import PQRS from "./pages/pqrs";
import Policies from "./pages/policies";
import CodeOfEthics from "./pages/codeOfEthics";
import Certifications from "./pages/certifications";
import Brochure from "./pages/brochure";
import Terms from "./pages/termsConditions";

// Additional Pages
import Company from "./pages/company";
import Sustainability from "./pages/sustainability";
import Operations from "./pages/operations";
import Services from "./pages/services";

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop /> {/* Ensure this is placed directly inside Router */}
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/company" element={<Layout><Company /></Layout>} />
          <Route path="/sustainability" element={<Layout><Sustainability /></Layout>} />
          <Route path="/operations" element={<Layout><Operations /></Layout>} />
          <Route path="/services" element={<Layout><Services /></Layout>} />
          <Route path="/contact-us" element={<Layout><ContactUs /></Layout>} />
          <Route path="/environmental/monitoring" element={<Layout><Monitoring /></Layout>} />
          <Route path="/environmental/laboratory" element={<Layout><Laboratory /></Layout>} />
          <Route path="/environmental/consultancy" element={<Layout><Consultancy /></Layout>} />
          <Route path="/environmental/equipment" element={<Layout><Equipment /></Layout>} />
          <Route path="/environmental/Investigation" element={<Layout><Investigation /></Layout>} />
          <Route path="/environmental/decarbonization" element={<Layout><Decarbonization /></Layout>} />
          <Route path="/oil-gas/drilling-fluids" element={<Layout><DrillingFluids /></Layout>} />
          <Route path="/oil-gas/completion-fluids" element={<Layout><CompletionFluids /></Layout>} />
          <Route path="/oil-gas/solid-control" element={<Layout><SolidControl /></Layout>} />
          <Route path="/oil-gas/consulting" element={<Layout><Consulting /></Layout>} />
          <Route path="/oil-gas/chemical-products" element={<Layout><ChemicalProducts /></Layout>} />
          <Route path="/work-with-us" element={<Layout><WorkWithUs /></Layout>} />
          <Route path="/pqrs" element={<Layout><PQRS /></Layout>} />
          <Route path="/policies" element={<Layout><Policies /></Layout>} />
          <Route path="/code-of-ethics" element={<Layout><CodeOfEthics /></Layout>} />
          <Route path="/certifications" element={<Layout><Certifications /></Layout>} />
          <Route path="/brochure" element={<Layout><Brochure /></Layout>} />
          <Route path="/Terms" element={<Layout><Terms /></Layout>} />
          <Route path="*" element={<Layout><NotFound /></Layout>} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;